exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:769px){#page-header.headroom--unpinned .logo[data-v-1773f977]{margin-top:13px}#page-header.headroom--unpinned .logo svg[data-v-1773f977]{width:90px}}@media (min-width:1141px){#page-header.headroom--unpinned .logo[data-v-1773f977]{margin-top:13px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1773f977","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/Logo.vue
// module id = 415
// module chunks = 0